import { useState } from "react";
import axios from "axios";
import { Download, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { toast } from "sonner";
import { API } from "@/lib/api";

export function LeadMagnetModal({ open, onOpenChange }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Por favor, introduce tu email");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/lead-magnet`, { email, nombre: name });
      toast.success("Checklist enviado a tu email");
      onOpenChange(false);
      setEmail("");
      setName("");
    } catch (err) {
      toast.error("Error al enviar. Inténtalo de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md bg-gray-900 border-gray-700" data-testid="lead-magnet-modal">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-white">Descarga tu checklist gratuito</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          <p className="text-gray-400 text-sm">Introduce tu email y te enviaremos los 10 errores legales más comunes al usar IA en medicina estética.</p>
          <div>
            <label className="form-label">Nombre (opcional)</label>
            <Input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Tu nombre" className="form-input mt-2" data-testid="lead-input-name" />
          </div>
          <div>
            <label className="form-label">Email *</label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@email.com" className="form-input mt-2" required data-testid="lead-input-email" />
          </div>
          <Button type="submit" className="w-full btn-primary" disabled={loading} data-testid="lead-submit-button">
            {loading ? (<><Loader2 className="w-4 h-4 animate-spin" />Enviando...</>) : (<><Download className="w-4 h-4" />Enviar checklist</>)}
          </Button>
          <p className="text-xs text-gray-500 text-center">No compartiremos tu email con terceros.</p>
        </form>
      </DialogContent>
    </Dialog>
  );
}
